import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';
import config from '../config/config';

const USC = () => {
  const [title, setTitle] = useState('USC');
  const [content, setContent] = useState('');
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [metaKeywords, setMetaKeywords] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-usc-content`);
        if (response.data.success) {
          const pageContent = response.data.data['page-content'];
          setTitle(pageContent.title);
          setContent(pageContent.content);

          // Set SEO metadata
          const seo = response.data.data['page-seo'];
          setMetaTitle(seo.meta_title);
          setMetaDescription(seo.meta_description);
          setMetaKeywords(seo.meta_keyword);
        }
      } catch (error) {
        console.error('Failed to fetch content:', error);
      }
    };

    fetchContent();
  }, []);

  useEffect(() => {
    // Update document head with SEO metadata
    document.title = metaTitle || 'Default Title';
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    const metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDescription || '');
    } else {
      const newMetaDescriptionTag = document.createElement('meta');
      newMetaDescriptionTag.name = 'description';
      newMetaDescriptionTag.content = metaDescription || '';
      document.head.appendChild(newMetaDescriptionTag);
    }

    if (metaKeywordsTag) {
      metaKeywordsTag.setAttribute('content', metaKeywords || '');
    } else {
      const newMetaKeywordsTag = document.createElement('meta');
      newMetaKeywordsTag.name = 'keywords';
      newMetaKeywordsTag.content = metaKeywords || '';
      document.head.appendChild(newMetaKeywordsTag);
    }
  }, [metaTitle, metaDescription, metaKeywords]);

  return (
    <div>
      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/">
                <img src={staticlogo} alt="Logo" /> PatreonPass
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section className="inner_static">
        <div className="container">
          <div className="row">
            <div className="page_title_header">{title}</div>
            <div className="page_content_static">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default USC;
